<template>
  <div class="subcat-select">
    <div v-if="loading && data == null" class="subcat-select__loader">
      Nalaganje...
    </div>
    <div v-else-if="data == null" class="subcat-select__loaderror">
      Napaka pri nalaganju!
    </div>
    <div v-else :class="['subcat-select__children', {'subcat-select__children--collapsed': collapsed}]">
      <subcat-entry v-for="option in data" :key="option.id" :data="option" :name="name" :values="values" :id="id" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CollapsibleMixin from '../../form_builder/CollapsibleMixin.vue';
import SubcatEntry from './SubcatEntry.vue';

Vue.mixin(CollapsibleMixin);

export default {
  name: 'subcat-select',
  props: {
    name: { type: String, required: true },
    id: { type: String, required: true },
    loadfunc: { type: Function, required: true },
    value: { type: String, default: '[]' },
  },
  mounted() {
    this.loadfunc((err, data) => {
      this.loading = false;
      if (err) throw new Error(err);
      this.data = data;
    });
    this.values = JSON.parse(this.value);
  },
  data() {
    return {
      loading: true,
      data: null,
      values: null,
    };
  },
  components: {
    SubcatEntry,
  },
};
</script>

<style>
.subcat-select {
  font-size: 12px;
  line-height: 17px;
}

.subcat-select__children {
  padding-left: 20px;
}

.subcat-select > .subcat-select__children {
  padding-left: 0;
}

.subcat-select__expando {
  line-height: 25px;
  padding-left: 25px;
  position: relative;
}

.subcat-select__collapse-button {
  border: 0;
  background: none;
  width: 25px;
  height: 25px;
  text-align: center;
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.subcat-select__label label {
  line-height: 25px;
  margin-bottom: 0;
  font-weight: 400;
}

.subcat-select__label {
  position: relative;
}

.subcat-select__label .help-box-container {
  position: absolute;
  top: 4px;
  right: 0;
}

.subcat-select__label .help-box-container ~ .help-box-container {
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/epravnik/widgets/SubcatSelect.vue